import { useContext } from 'react';
import { DataAccessContext } from '@axo/shared/data-access/provider';
import { permissions } from '@axo/shared/data-access/types';

interface UseCanTransferApplicationParams {
  applicationOwnerId?: string;
}

/**
 * Determines if the current user can transfer an application
 *
 * Rules:
 * - Managers can transfer any application in their market
 * - Sales can only transfer their own applications
 */
export const useCanTransferApplication = ({
  applicationOwnerId,
}: UseCanTransferApplicationParams): boolean => {
  const { state } = useContext(DataAccessContext);
  const user = state.user;

  if (!user) return false;

  const currentUserId = user.clientID;
  const userRoles = user.roles?.map((role) => role.Name) || [];

  // Managers can transfer any application
  if (userRoles.includes(permissions.RoleName.Manager)) return true;

  // Sales can only transfer their own applications
  if (userRoles.includes(permissions.RoleName.Sales) && applicationOwnerId === currentUserId) {
    return true;
  }

  return false;
};
